var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconXLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1484 12L18.5867 6.56169C18.9009 6.24753 18.9009 5.72753 18.5867 5.41336C18.2725 5.09919 17.7525 5.09919 17.4384 5.41336L12 10.8517L6.56169 5.41336C6.24753 5.09919 5.72753 5.09919 5.41336 5.41336C5.09919 5.72753 5.09919 6.24753 5.41336 6.56169L10.8517 12L5.41336 17.4384C5.09919 17.7525 5.09919 18.2725 5.41336 18.5867C5.57586 18.7492 5.78169 18.825 5.98753 18.825C6.19336 18.825 6.39919 18.7492 6.56169 18.5867L12 13.1484L17.4384 18.5867C17.6009 18.7492 17.8067 18.825 18.0125 18.825C18.2184 18.825 18.4242 18.7492 18.5867 18.5867C18.9009 18.2725 18.9009 17.7525 18.5867 17.4384L13.1484 12Z",
    fill: "#454B53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXLine);
export default __webpack_public_path__ + "static/media/icon_x_line.1b2a212f.svg";
export { ForwardRef as ReactComponent };